// @ts-ignore
const NullWebFont = {
    load: () => { },
};
const isBrowser = typeof window !== 'undefined';
export default isBrowser ? require('webfontloader') : NullWebFont;
